<template>
  <div>
    <div class='dovemed-container'>
      <div class='dovemed-wrapper text-center signup-page'>
        <div class='signup-container'>
          <div class='row'>
            <div class='col-md-2 col-sm-6 mb-2'>
              <img
                class='signup-avatar'
                src='../../assets/logo.png'
                alt
              />
            </div>
            <div class='col-md-10 col-sm-6 text-left align-self-center pl-4'>
              <h4 class='hyper-link mb-1'>Welcome</h4>
              <h4 class='mb-1'>Dr. Michael Albaum</h4>
            </div>
          </div>
          <hr />
          <div class='text-left'>
            <p>To get started, please choose a display name</p>
            <label
              for='displayName'
              class='bold-text mb-1'
            >Display Name</label>
            <a-input
              :size="'large'"
              placeholder="Enter name"
            />
          </div>

          <div class='buttons mt-5'>
            <span class='align-self-center'>
              Not Dr. Michael Albaum? Please click
              <span class='hyper-link cp'>Here</span>
            </span>
            <router-link to='claimProfile'>
              <button class='dovemed-button primary-button font-white' :style="{background: getPrimaryColor()}">NEXT</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserName'
}
</script>

<style lang='scss' scoped>
.signup-page {
  padding: 70px;
}

.signup-container {
  max-width: 550px;
  margin: auto;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.signup-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/SignupUserName.vue